import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropdownService } from '../services/dropdown.service';
import { IndicatorConfig } from '../model/dropdown.model';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
    DropdownService,
  ],
})
export class SelectComponent
  implements OnInit, ControlValueAccessor, AfterViewInit, OnChanges
{
  constructor(
    private dropdown: DropdownService,
    private cdf: ChangeDetectorRef
  ) {}

  style: { top?: string; left?: string; right?: string } = {};

  @ViewChild('input')
  inputField!: ElementRef;
  @ViewChild('customInput')
  customInputField!: ElementRef;
  @ViewChild('options')
  optionsEle!: ElementRef;
  @Input() styles: any;
  @Input() isAbsolute: boolean = false;
  @Input() handleNA: boolean = false;
  @Input() allowCustomOption: boolean | undefined = false;
  @Input() naValue: string = 'NA';
  @Input() allowDynamicPosition = true;
  @Input() options: any[] = []; // to handle custom option

  rightIcon = String.fromCharCode(0x2713);

  private multiple!: boolean;
  markAsSelectAll() {
    const excludeCount =
      this.handleNA && this.dropdown.getMenuItems().includes(this.naValue)
        ? 2
        : 1;
    if (
      this.dropdown.multiple &&
      this.dropdown.getMenuItems().length > 1 &&
      this.dropdown.getMenuItems().length - excludeCount ===
        this.dropdown.multipleValues.value.length
    ) {
      this.dropdown.selectAll(this.id);
      this.value = this.dropdown.getMenuItems()[0];
    }
  }
  ngAfterViewInit(): void {
    // window.addEventListener('click', (event:Event) => {

    //     event.stopPropagation()
    //     this.dropdown.closeMenu();
    //     this.removeActiveFocus();
    //     this.resetCustomValue();

      
    // });
    this.dropdown.multipleValues.subscribe((mutipleValue) => {});
    this.markAsSelectAll();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.markAsSelectAll();
    /**
     * to reset the previous selected options pass the input resetSelectedValues as true
     */
    if (changes?.['resetSelectedValues']?.previousValue != changes?.['resetSelectedValues']?.currentValue && changes?.['resetSelectedValues']?.currentValue == true) {
      this.dropdown.clearAllSelected(this.id);
      this.value = '';
      this.selectedValue = '';
    }
  }

  isMenuOpened: boolean = false;
  isCustomOption = false;
  isCustomClick = false
  @Input() IsDisabled: boolean = false;
  @Input() isReadOnly: boolean = true;
  @Input() IsRequired: boolean = false;
  @Input() readOnly: boolean = true;
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() isSearchable!: boolean;
  @Input()
  id!: string;
  @Input()
  errorId!: string;
  value: any;
  isClicked: boolean = false;
  isTabClick: boolean = false;
  onTouched: any = () => {};
  selectedValue = '';
  enableCustomOption = false;
  onChange: any = (selectedoption: string) => {};
  hasInputFocus: boolean = false;
  isScrollEnabled: boolean = true;
  @Input() returnArray = true;
  @Input() minWidth!: string | undefined;
  @Input() width!: string | undefined;
  @Output() OnCustumValueAdded: EventEmitter<any> = new EventEmitter<any>();
  @Input() canSelect: boolean = false;
  @Output() hideOthers: EventEmitter<any> = new EventEmitter<any>();

  indicator: IndicatorConfig | false = false;
  valueCache: any = [];
  @Input() set indicatorConfig(indicator: IndicatorConfig | false) {
    this.indicator = false;
    this.indicator = { ...indicator } as IndicatorConfig;
  }

  writeValue(value: any): void {
    if (this.multiple) {
      let selectedValue = Array.isArray(this.value)
        ? this.value
        : this.value.split(',');
      selectedValue.map((val: any) => {
        this.dropdown.setSelectedMenu(val);
      });
    } else {
      this.value = value;
      this.dropdown.setSelectedMenu(this.value);
    }
    if (!value) {
      this.dropdown.setSelectedMenu('');
    }
    if (value && value !== ' ') {
      this.dropdown.defaultValue = value;
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.IsDisabled = isDisabled;
  }
  @Input() Value!: string | number;
  @Input() resetSelectedValues: boolean = false;
  focusInputElement() {
    this.inputField?.nativeElement.focus();
  }

  ngOnInit(): void {
    const isMenuItems = this.dropdown.getMenuItems();

    if (this.canSelect) {
      this.dropdown.multiple = true;
    }
    this.dropdown.isSearchable = this.isSearchable;
    this.dropdown.returnArray = this.returnArray;
    this.multiple = this.dropdown.multiple;
    this.dropdown.id = this.id;
    this.dropdown.handleNA = this.handleNA;
    this.dropdown.naValue = this.naValue;
    if (this.multiple) {
      this.dropdown.selectAllState.subscribe((state) => {
        if (state && this.dropdown.isSelectAll) {
          this.dropdown.selectAll(this.id);
          this.value = state;
          this.selectedValue = state;
        } else {
          this.dropdown.clearAllSelected(this.id);
          this.value = '';
          this.selectedValue = '';
        }
      });

      this.dropdown.multipleValues.subscribe((val) => {
        // this.actualValue = val
        if (val && !this.dropdown.isSelectAll) {
          let dropDownValue = val;
          if (!this.isSearchable) {
            this.value = dropDownValue;
          } else {
            this.selectedValue = dropDownValue.join(',');
          }

          const selectAllElement = document.querySelector(
            `#${this.id} app-menu-item[data-selcet-all="true"] input`
          ) as HTMLInputElement;
          if (selectAllElement?.checked) {
            selectAllElement.checked = false;
          }
        }
      });
    } else {
      this.dropdown.dropDownState.subscribe((dropDownState) => {
        this.value = dropDownState.selectedMenu;
        this.updateValue(dropDownState.selectedMenu);
      });
    }
    this.dropdown.isMenuOpened.subscribe((isOpened) => {
      this.isMenuOpened = isOpened;
      if (isOpened) {
        if (this.hideOthers) {
          this.hideOthers.emit(true);
        }
      }
    });
  }

  updateValue(value: any) {
    this.isClicked = false;
    this.Value = value;
    this.onChange(this.value);
    this.dropdown.setDropDownValue(value);
  }

  resetValue() {
    const menuItemsvalue: any[] = this.dropdown.getMenuItems();
    if (!this.allowCustomOption) {
      if (!menuItemsvalue.includes(this.value) && !this.multiple) {
        this.value = this.dropdown.defaultValue;
        this.updateValue(this.dropdown.defaultValue);
      }
      if (this.multiple && this.value) {
        let valuesArray: any[] = [];
        if (Array.isArray(this.value)) {
          valuesArray = this.value;
        } else {
          valuesArray = this.value.split(',');
        }
        valuesArray?.forEach((val) => {
          if (
            !menuItemsvalue
              .map((el) => el?.toLowerCase())
              .includes(val.toLowerCase())
          ) {
            this.value = this.dropdown.defaultValue;
            this.updateValue(this.dropdown.defaultValue);
            this.dropdown.clearAllMutipleValues();
            this.optionsEle.nativeElement
              .querySelectorAll("input[type='checkbox']")
              .forEach((el: any) => {
                el.checked = false;
              });
          }
        });
      }
    }
  }
  flag: boolean = false;

  handleBlur() {
    this.isArraowClicked = false;

    if (!this.Value) {
      const menuItems: any[] = [
        ...this.optionsEle.nativeElement.querySelectorAll(
          '.menu-item--wrapper'
        ),
      ];
      menuItems.forEach((el) => el.classList.remove('menu-active'));
    }

    if (!this.isTabClick) {
      setTimeout(() => {
        if (this.isClicked) {
          this.focusInputElement();
          this.isClicked = false;
          return;
        }
        if (this.multiple && this.dropdown.isInputDirty) {
          this.dropdown.setInputblur(true);
          this.dropdown.isInputDirty = false;
        } else {
          this.onTouched();
        }

        this.removeActiveFocus()
        this.dropdown.closeMenu();
        this.hasInputFocus = false;
        if (this.isSearchable) {
          this.dropdown.setDropDownValue('');
          this.value = this.selectedValue;
        } else {
          this?.resetValue();
        }
      }, 250);
    }
  }
  handleOptionsClick(event: any) {
    this.isClicked = true;
    if (this.multiple) {
      event.stopPropagation();
      this.dropdown.openMenu();
    }
  }
  iconClick(event: any) {
    if (!this.hasInputFocus) {
      this.focusInputElement();
    }
    this.onInputClick(event);
  }
  onInputClick(event: any) {
    this.optionsEle.nativeElement.style.opacity = 0;
    event.stopPropagation();
    let inputBoundingClient =
      this.inputField.nativeElement.getBoundingClientRect();
    setTimeout(() => {


     
      // let optionBoundingClient =
      //   this.optionsEle.nativeElement.getBoundingClientRect();
       
        
      const windowHeight = window.innerHeight;
      const parentWidth = inputBoundingClient.width;
      const actualWidth = parentWidth < 200 ? 200 : parentWidth;
      const totalHeight = windowHeight - inputBoundingClient.y;
      let optsTop = inputBoundingClient.y + inputBoundingClient.height;
      optsTop += this.allowDynamicPosition ? window.scrollY : 0;

        requestAnimationFrame(() => {
       
          let optionBoundingClient =
            this.optionsEle.nativeElement.getBoundingClientRect();

          const actualHeight = optionBoundingClient.height + 80;

          if (totalHeight >= actualHeight) {
            this.optionsEle.nativeElement.style.top = `${optsTop}px`;
          } else {
            this.optionsEle.nativeElement.style.top = `${
              inputBoundingClient.y +
              window.scrollY -
              (optionBoundingClient.height + 20)
            }px`;
          }

          
        });
        
        this.optionsEle.nativeElement.style.width = `${actualWidth}px`;
        this.optionsEle.nativeElement.style.left = `${inputBoundingClient.x}px`;
        this.optionsEle.nativeElement.style.opacity = 1;

    });

    this.dropdown.toggelMenu();

    this.dropdown.setInputblur(false);

    this.hasInputFocus = true;
    if (this.value && this.isSearchable) {
      this.value = '';
    }
  }
  removeActiveFocus() {
    const menuItems = this.getMenuItems();
    menuItems.forEach((item) => {
      item.classList.remove('menu-focus');
    });
  }
  isArraowClicked: boolean = false;
  count: number = 0;
  getMenuItems(): any[] {
    const menuItems: any[] = [
      ...this.optionsEle.nativeElement.querySelectorAll('.menu-item--wrapper'),
    ];
    return menuItems;
  }
  getElement(selector: string): HTMLElement {
    const element = this.optionsEle.nativeElement.querySelector(selector);
    return element as HTMLElement;
  }
  getActiveIndex(): number {
    const menuItems: any[] = this.getMenuItems();
    const activeIndex = menuItems.findIndex((el: any) =>
      el.classList.contains('menu-focus')
    );
    return activeIndex;
  }
  toggleClassMenuItems(action: 'remove' | 'add', index: number) {
    const menuItems: any[] = this.getMenuItems();
    menuItems[index].classList[action]('menu-focus');
  }

  setItemValue() {
    this.optionsEle.nativeElement.childNodes.forEach((el: any) => {
      el.addEventListener('keydown', (elEvent: any) => {
        const elkey = elEvent['key'];
        if (elkey === 'Enter') {
          elEvent.preventDefault();
          const elemet = el.querySelector('.menu-item--wrapper') as HTMLElement;
          const value: any = elemet.getAttribute('data-menu-value');
          this.dropdown.setSelectedMenu(value);
          this.dropdown.closeMenu();
          this.isTabClick = false;
        }
      });
    });
  }
  moveNextActive() {
    const menuItems: any[] = this.getMenuItems();
    const activeIndex: number = this.getActiveIndex();
    if (activeIndex < menuItems.length - 1) {
      if (activeIndex < 0) {
        this.toggleClassMenuItems('add', 0);
        menuItems[0].focus();
        return;
      }
      this.toggleClassMenuItems('remove', activeIndex);
      this.toggleClassMenuItems('add', activeIndex + 1);
      menuItems[activeIndex + 1].focus();
    } else {
      this.toggleClassMenuItems('remove', menuItems.length - 1);
      this.toggleClassMenuItems('add', 0);
      menuItems[0].focus();
    }
  }

  handleOptionKeyDown(event: any) {
    if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.moveNextActive();
    }
    if (event.key === 'Escape') {
      this.dropdown.closeMenu();
      this.focusInputElement();
    }
    if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.movePrevActive();
    }
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.setItemValue();
      this.focusInputElement();
      this.removeActiveFocus();
    }
  }

  movePrevActive() {
    const menuItems: any[] = [
      ...this.optionsEle.nativeElement.querySelectorAll('.menu-item--wrapper'),
    ];
    const activeIndex = menuItems.findIndex((el: any) =>
      el.classList.contains('menu-focus')
    );
    if (activeIndex > 0 && activeIndex < menuItems.length) {
      this.toggleClassMenuItems('remove', activeIndex);
      this.toggleClassMenuItems('add', activeIndex - 1);
      menuItems[activeIndex - 1].focus();
    } else {
      this.toggleClassMenuItems('remove', 0);
      this.toggleClassMenuItems('add', menuItems.length - 1);
      menuItems[menuItems.length - 1].focus();
    }
  }
  handleKeyDown(event: any) {
    const key = event['key'];
    const inputField = this.inputField?.nativeElement;
    const menuItems = this.getMenuItems();

    if (key === 'Escape') {
      this.focusInputElement();
      this.dropdown.closeMenu();
    }
    if (key === 'ArrowDown' && this.isMenuOpened) {
      this.isTabClick = true;

      this.isArraowClicked = true;
      event.preventDefault();
      this.moveNextActive();
      this.toggleClassMenuItems('add', 0);
      menuItems[0].focus();
    }
    if (key === 'ArrowUp') {
      this.isTabClick = true;
      this.isArraowClicked = true;
      event.preventDefault();
    }
    if (key === 'Tab' && this.isMenuOpened) {
      this.isTabClick = true;
    }
    if (key === ' ' || key === 'Enter') {
      if (this.isArraowClicked && this.isMenuOpened) {
        this.isArraowClicked = false;
        const elemet = this.getElement('.menu-active');
        const value: any = elemet.getAttribute('data-menu-value');
        this.dropdown.setSelectedMenu(value);
      }
      event.preventDefault();
      this.dropdown.toggelMenu();
      this.setItemValue();
    }
  }
  focusCustomelementFiled() {
    this.customInputField?.nativeElement.focus();
  }
  handleCustomOptions(event: any) {
    event.stopPropagation();
    this.enableCustomOption = true;
    setTimeout(() => {
      this.valueCache = this.value;
      this.value = '';
      this.focusCustomelementFiled();
    });
  }

  addCustomOption() {

    this.isCustomClick = true
    if (this.value) {
      // For custom options :: handling custom added option
      this.dropdown.defaultValue = this.value
      this.options.unshift(this.value);
      this.dropdown.setMenuItems(this.value)
      this.dropdown.setSelectedMenu(this.value);
      this.enableCustomOption = false;
      this.valueCache = [];
      this.dropdown.setInputblur(true);
    } else {
      this.resetCustomValue();
    }
  }

  resetCustomValue() {
    if (this.enableCustomOption) {
      this.enableCustomOption = false;
      this.value = this.valueCache;
      this.updateValue('');
      this.valueCache = [];
    }
  }

  handleCustomValueBlur() {
    setTimeout(() => {
      if (!this.isCustomClick) {
        this.resetCustomValue()
        this.isCustomClick = false;
      }
    }, 250);
  }

  handleCustomValueClick(event: any) {
    event.stopPropagation();
    this.isCustomClick = true;
  }
}